module.exports = __webpack_public_path__ + "static/maitri-697a43f9946d3eb623b1eec460ed37d1.webp";